import client from "./client";

export const listDuties = async (params) => (await client.get("/duties", { params })).data;
export const createDuty = async (body) => (await client.post("/duties", body)).data;
export const updateDuty = async (id, body) => (await client.patch(`/duties/${id}`, body)).data;
export const deleteDuty = (id) => client.delete(`/duties/${id}`);
export const myDutiesToday = async () => (await client.get("/duties/mine/today")).data;
export const dutyGeoCheck = async (duty_id, latitude, longitude) =>
  (await client.get("/duties/geo-check", { params: { duty_id, latitude, longitude } })).data;
